import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.match";
import $ from 'jquery';

// 检测客户端浏览器信息（类型和版本）
export function detectBrowserInfo() {
  var browserInfo = {
    type: 'unknow',
    version: '',
    majorVersion: 0
  };
  var userAgent = navigator.userAgent.toLowerCase();
  var matches;
  if (/msie\s*|trident\/7/i.test(userAgent)) {
    // IE浏览器
    browserInfo.type = 'ie';
    matches = userAgent.match(/trident\/(\d+(\.\d+)*)/i);
    if (matches) {
      browserInfo.version = {
        '4.0': '8.0',
        '5.0': '9.0',
        '6.0': '10.0',
        '7.0': '11.0'
      }[matches[1]];
    } else {
      matches = userAgent.match(/msie\s*(\d+(\.\d+)*)/i);
      if (matches) {
        browserInfo.version = matches[1];
      }
    }
  } else if (/opr/i.test(userAgent) || /opera/i.test(userAgent)) {
    // Opera浏览器
    browserInfo.type = 'opera';
    matches = userAgent.match(/opr\/(\d+(\.\d+)*)/i);
    if (matches) {
      browserInfo.version = matches[1];
    } else {
      matches = userAgent.match(/opera.*version\/(\d+(\.\d+)*)/i);
      if (matches) {
        browserInfo.version = matches[1];
      }
    }
  } else {
    // 其他浏览器
    var simpleBrowserList = [{
      name: 'edge',
      reg: /edge\/(\d+(\.\d+)*)/i
    }, {
      name: 'firefox',
      reg: /firefox\/(\d+(\.\d+)*)/i
    }, {
      name: 'chrome',
      reg: /chrome\/(\d+(\.\d+)*)/i
    }, {
      name: 'safari',
      reg: /version\/(\d+(\.\d+)*).*safari/i
    }];
    for (var i = 0; i < simpleBrowserList.length; i++) {
      matches = userAgent.match(simpleBrowserList[i]['reg']);
      if (matches) {
        browserInfo.type = simpleBrowserList[i]['name'];
        browserInfo.version = matches[1];
        break;
      }
    }
  }
  if (browserInfo.version) {
    browserInfo.majorVersion = browserInfo.version.split('.')[0] * 1;
  }
  return browserInfo;
}

// xml字符串转xml文档对象
export function XMLStr2XMLDoc(txt) {
  var xmlDoc;
  if (window.DOMParser) {
    var parser = new DOMParser();
    xmlDoc = parser.parseFromString(txt, 'text/xml');
  } else {
    // IE
    xmlDoc = new ActiveXObject('Microsoft.XMLDOM');
    xmlDoc.async = 'false';
    xmlDoc.loadXML(txt);
  }
  return xmlDoc;
}

// 用实体替换特殊字符
export function replaceWithEntity(str) {
  str = '' + str; // 参数必须转换为字符串，否则可能会报错
  var entityList = [{
    ch: '&',
    entity: '&amp;'
  }, {
    ch: '<',
    entity: '&lt;'
  }, {
    ch: '>',
    entity: '&gt;'
  }, {
    ch: '"',
    entity: '&quot;'
  }];
  $.each(entityList, function (index, element) {
    str = str.replace(new RegExp(element.ch, 'g'), element.entity);
  });
  return str;
}

// 检测客户端浏览器类型
export function detectBrowser() {
  return detectBrowserInfo()['type'];
}

// 检测客户端操作系统
export function detectOS() {
  var platform = navigator.platform.toLowerCase();
  var isWin = platform === 'win32' || platform === 'win64' || platform === 'windows';
  if (isWin) return 'windows';
  var isMac = platform === 'mac68k' || platform === 'macppc' || platform === 'macintosh' || platform === 'macintel';
  if (isMac) return 'mac';
  var isUnix = platform === 'x11' && !isWin && !isMac;
  if (isUnix) return 'unix';
  var isLinux = String(platform).indexOf('linux') > -1;
  if (isLinux) return 'linux';
  return 'unknow';
}

/*
* 调用方式
* var template1="apple is %1，banana is %2";
* var result1=template1.formatForLang("red","yellow");
*/
window.String.prototype.formatForLang = function (args) {
  var result = this;
  if (arguments.length > 0) {
    for (var i = 0; i < arguments.length; i++) {
      if (arguments[i] !== undefined) {
        var reg = new RegExp('(%' + (i + 1) + ')', 'g');
        result = result.replace(reg, arguments[i]);
      }
    }
  }
  return result;
};

// 异或加密
export function XOREncrypt(md5, nonce) {
  var list = [];
  for (var i = 0; i < md5.length; i++) {
    var intNum = md5[i].charCodeAt().toString(2) ^ nonce;
    list.push(intNum);
  }
  return list.join(' ');
}